const getLinkIdFromUrl = (url: string): string => {
    return url.split('/').pop() || ''
}

export default getLinkIdFromUrl